import Box from '@mui/material/Box';

import logo from 'assets/logo.svg';

import { colors } from 'styles';

import { HeaderStyled, HeaderNavigation } from './Header.style';
import { NavigationItem } from './DesktopHeader.style';
import { ContactUsButton, LogoLink } from './MobileHeader.style';

import { Link, useLocation } from 'react-router-dom';
import {
  aboutMeta,
  autoDockingMeta,
  automatedDataPipelinesMeta,
  careersMeta,
  computerMeta,
  homeMeta,
  industriesMeta,
  maritimeMeta,
  mobileMeta,
  otherMeta,
  platformMeta,
} from 'constants/pages';
import { useContext } from 'react';
import { ScrollContext } from 'context/ScrollContext';
import { Dropdown, DropdownItem } from './Dropdown';

export type DesktopHeaderProps = { openModal: () => void };

export const companyItems: DropdownItem[] = [
  { name: 'About us', to: aboutMeta.url },
  { name: 'Careers', to: careersMeta.url },
];

export const industriesItems: DropdownItem[] = [
  { name: 'All', to: industriesMeta.url },
  { name: 'Maritime', to: maritimeMeta.url },
  { name: 'Mobile Machines', to: mobileMeta.url },
  { name: 'Machine Vision', to: computerMeta.url },
  { name: 'Others', to: otherMeta.url },
];

export const applicationsItems: DropdownItem[] = [
  { name: 'Training', to: automatedDataPipelinesMeta.url },
  { name: 'Testing', to: autoDockingMeta.url },
];

export const DesktopHeader = ({ openModal }: DesktopHeaderProps) => {
  const isScrolled = useContext(ScrollContext);
  const { pathname } = useLocation();
  const isIndustriesPages = [
    maritimeMeta.url,
    mobileMeta.url,
    computerMeta.url,
    otherMeta.url,
  ].includes(pathname);
  const color = isScrolled || isIndustriesPages ? colors.darkGray : 'white';

  return (
    <>
      <HeaderStyled
        component="header"
        sx={{ background: isScrolled || isIndustriesPages ? 'white' : 'transparent' }}
      >
        <HeaderNavigation component="nav">
          <Box mr="auto">
            <LogoLink to={homeMeta.url}>
              <img src={logo} alt="logo icon" />
            </LogoLink>
          </Box>

          <Box width="100%" justifyContent="center" alignItems="center" display="flex">
            <Box mr={4}>
              <NavigationItem color={color}>
                <Link to={platformMeta.url} style={{ textDecoration: 'none', color: 'inherit' }}>
                  Platform
                </Link>
              </NavigationItem>
            </Box>

            <Dropdown
              isScrolled={isScrolled}
              label="Industries"
              items={industriesItems}
              color={color}
            />

            <Dropdown
              isScrolled={isScrolled}
              label="Applications"
              items={applicationsItems}
              color={color}
            />

            {/* <Box mr={4}>
              <NavigationItem color={color}>
                <Link to={''} style={{ textDecoration: 'none', color: 'inherit' }}>
                  Applications
                </Link>
              </NavigationItem>
            </Box> */}

            {/* <Box mr={4}>
              <NavigationItem color={color}>
                <Link to={''} style={{ textDecoration: 'none', color: 'inherit' }}>
                  Customer cases
                </Link>
              </NavigationItem>
            </Box> */}
            <Dropdown isScrolled={isScrolled} label="Company" items={companyItems} color={color} />

            {/* <Box mr={4}>
              <NavigationItem color={color}>
                <Link to={''} style={{ textDecoration: 'none', color: 'inherit' }}>
                  Company
                </Link>
              </NavigationItem>
            </Box> */}
          </Box>

          <Box ml={10}>
            <ContactUsButton
              onClick={openModal}
              color="secondary"
              variant={isScrolled ? 'outlined' : 'contained'}
            >
              Contact us
            </ContactUsButton>
          </Box>
        </HeaderNavigation>
      </HeaderStyled>
    </>
  );
};
